import { create } from 'zustand';
import type { HubProvider } from '../lib/api/domains/technicianHub';

interface CustomerDrawerState {
  opened: boolean;
  customerId: string | null;
  customerName: string;
  provider: HubProvider;
  /**
   * Zählt jeden openDrawer-Aufruf. Damit reagiert das Kunden-Modal auch dann,
   * wenn es bereits offen ist, aber hinter einem darüber liegenden Ticket-Cockpit
   * (Kunde → Ticket → Klick auf Kundenname): das Modal schließt sein
   * verschachteltes Cockpit und kommt wieder nach vorn — schrittweise Navigation.
   */
  requestSeq: number;
  openDrawer: (customerId: string, customerName: string, provider: HubProvider) => void;
  closeDrawer: () => void;
}

export const useCustomerDrawerStore = create<CustomerDrawerState>((set) => ({
  opened: false,
  customerId: null,
  customerName: '',
  provider: 'connectwise',
  requestSeq: 0,

  openDrawer: (customerId, customerName, provider) =>
    set((s) => ({ opened: true, customerId, customerName, provider, requestSeq: s.requestSeq + 1 })),

  closeDrawer: () =>
    set({ opened: false }),
}));
